const toggle = document.getElementById('menu-toggle');
const hamburger = toggle.querySelector('.hamburger');
const mobileMenu = document.getElementById('mobile-menu');
const body = document.getElementById('body');
const header = document.querySelector("header.primary");

// Mobile Menu Toggle
if (toggle && hamburger && mobileMenu && body) {
    toggle.addEventListener('click', () => {
        hamburger.classList.toggle('active');
        mobileMenu.classList.toggle('active');
        body.classList.toggle('overflow-hidden');

        if (mobileMenu.classList.contains('active') && header.classList.contains('sticky')) {
            header.style.height = '100%'
        } else {
            header.style.height = 'auto'
        }

    });
}

// Desktop Sub Menus
const menuItemsWithChildren = document.querySelectorAll('.desktop-menu .menu-item-has-children .toggle-submenu');

if (menuItemsWithChildren) {
    menuItemsWithChildren.forEach((menuItem) => {
        menuItem.addEventListener('click', function () {
            const expanded = this.getAttribute("aria-expanded");
            this.setAttribute("aria-expanded", expanded !== 'true');
            this.parentNode.classList.toggle('open');
        });
    });
}

// Mobile Sub Menus
const mobileMenuItemsWithChildren = document.querySelectorAll('.mobile-menu .menu-item-has-children .toggle-submenu-mobile');

if (mobileMenuItemsWithChildren) {
    mobileMenuItemsWithChildren.forEach((menuItem) => {
        menuItem.addEventListener('click', function () {
            const expanded = this.getAttribute("aria-expanded");
            this.setAttribute("aria-expanded", expanded !== 'true');
            this.parentNode.querySelector('.sub-menu').classList.toggle('toggled');
        })
    });
}

// Sticky Header Class for blur
function toggleStickyHeaderClass() {
    if (window.pageYOffset > 33) {
        header.classList.add("sticky");
    } else {
        header.classList.remove("sticky");
    }
}

window.onscroll = function () {
    toggleStickyHeaderClass()
};
